"use client";

import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const WhatsAppButton = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleOpen = () => setIsOpen(true);
        window.addEventListener("open-whatsapp-popup", handleOpen);
        return () => window.removeEventListener("open-whatsapp-popup", handleOpen);
    }, []);

    const openInNewTab = (url: string) => {
        window.open(url, "_blank", "noreferrer");
    };

    return (
        <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
            {isOpen && (
                <div className="bg-white rounded-xl shadow-xl p-3 w-64">
                    <p className="text-sm font-semibold text-gray-700 px-2 pb-2">
                        Contact us on WhatsApp
                    </p>

                    <button
                        onClick={() =>
                            openInNewTab("https://wa.me/6287808786357")
                        }
                        className="w-full px-3 py-3 rounded-lg hover:bg-gray-100 flex items-center gap-3 text-left duration-150"
                    >
                        <FontAwesomeIcon
                            icon={faWhatsapp}
                            className="text-green-500 text-2xl"
                        />
                        <div>
                            <p className="font-semibold text-gray-800">
                                Annabel Oktaviani Putri
                            </p>
                        </div>
                    </button>

                    <button
                        onClick={() =>
                            openInNewTab("https://wa.me/6281382137539")
                        }
                        className="w-full px-3 py-3 rounded-lg hover:bg-gray-100 flex items-center gap-3 text-left duration-150"
                    >
                        <FontAwesomeIcon
                            icon={faWhatsapp}
                            className="text-green-500 text-2xl"
                        />
                        <div>
                            <p className="font-semibold text-gray-800">
                                Chilva Almira Rizqi
                            </p>
                        </div>
                    </button>

                    <button
                        onClick={() =>
                            openInNewTab("https://wa.me/6281372529119")
                        }
                        className="w-full px-3 py-3 rounded-lg hover:bg-gray-100 flex items-center gap-3 text-left duration-150"
                    >
                        <FontAwesomeIcon
                            icon={faWhatsapp}
                            className="text-green-500 text-2xl"
                        />
                        <div>
                            <p className="font-semibold text-gray-800">
                                Jessen William
                            </p>
                        </div>
                    </button>
                </div>
            )}

            <div
                onClick={() => setIsOpen(!isOpen)}
                className="bg-defaultBlue w-16 h-16 rounded-full hover:scale-110 duration-200 cursor-pointer flex items-center justify-center"
            >
                <FontAwesomeIcon
                    icon={faWhatsapp}
                    className="text-white text-4xl"
                />
            </div>
        </div>
    );
};

export default WhatsAppButton;